import React from 'react';
import { Question, QuestionType } from '../types';
import QuestionDisplay from './QuestionDisplay';
import QuestionEditor from './QuestionEditor';

interface QuestionItemProps {
  question: Question;
  index: number;
  isEditing: boolean;
  isDragging: boolean;
  onEdit: () => void;
  onUpdate: (updates: Partial<Question>) => void;
  onTypeChange: (newType: QuestionType) => void;
  onDone: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onDragStart: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDragEnd: () => void;
}

const QuestionItem: React.FC<QuestionItemProps> = ({
  question,
  index,
  isEditing,
  isDragging,
  onEdit,
  onUpdate,
  onTypeChange,
  onDone,
  onDuplicate,
  onDelete,
  onDragStart,
  onDragOver,
  onDragEnd,
}) => {
  return (
    <div className={`border ${isEditing ? 'border-blue-400' : 'border-gray-200'} rounded-lg mb-4 bg-white shadow-sm transition-all ${isDragging ? 'cursor-move' : ''}`}>
      <div className="p-4">
        {isEditing ? (
          <QuestionEditor
            question={question}
            onUpdate={onUpdate}
            onTypeChange={onTypeChange}
            onDone={onDone}
          />
        ) : (
          <QuestionDisplay
            question={question}
            index={index}
            isDragging={isDragging}
            onEdit={onEdit}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDragEnd={onDragEnd}
          />
        )}
      </div>
    </div>
  );
};

export default QuestionItem; 